/* eslint-disable react/prop-types */ // TODO: add props
import { useMathQuillStatic } from 'core/hooks';

const stripEmptyTextNodes = (str) => str.replace(/\\text{\s*}/g, '');

const StaticEquation = ({ equation }) => {
  const [ref] = useMathQuillStatic();
  const cleanedEquation = stripEmptyTextNodes(equation);

  return <span ref={ref}>{cleanedEquation}</span>;
};

export default StaticEquation;
